import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');

  // Data profile host dengan properti showSocial untuk kontrol tampilan
  const hosts = [
    {
      id: 1,
      userId: "3230086",
      name: "Pangeran22",
      role: "OWNER MANAGEMENT",
      experience: "5+ Years",
      rating: 4.9,
      description: "Spesialis dalam manajemen event dan koordinasi tim. Berpengalaman menangani berbagai acara skala besar.",
      photo: "https://qnoss.momoindo.com/album/3230086/202604240113380731.jpg",
      social: {
        instagram: "wan_antz22",
        whatsapp: "+6285930139333",
        email: "wangameroffial@gmail.com"
      },
      showSocial: true // Set true untuk menampilkan, false untuk menyembunyikan
    },
    {
      id: 2,
      userId: "5245752",
      name: "静晓 (Jìng Xiǎo)",
      role: "Technical Host",
      experience: "4+ Years",
      rating: 4.2,
      description: "Together, we can achieve greatness. Let's make it happen!",
      photo: "https://qnoss.momoindo.com/album/5245752/202604210735399000.jpg",
      social: {
        instagram: "",
        whatsapp: "",
        email: ""
      },
      showSocial: false // Set false untuk menyembunyikan tombol sosial
    },
   {
     id:3,
     userId: "5088583",
     name: "🔐ลýลик¹⁹⁹⁹🔐",
     role: "Technical Host",
     experience: "4+ Years",
     rating: 4.2,
     description: "Together, we can achieve greatness. Let's make it happen!",
     photo: "https://qnoss.momoindo.com/album/5088583/202604101141102322.jpg",
     social: {
        instagram: "",
        whatsapp: "+",
        email: ""
      },
      showSocial: false // Set false untuk menyembunyikan tombol sosial
    },
   {
     id:4,
     userId: "3671909",
     name: "ฬᴹ•°ichaa",
     role: "Technical Host",
     experience: "4+ Years",
     rating: 4.2,
     description: "Together, we can achieve greatness. Let's make it happen!",
     photo: "https://qnoss.momoindo.com/live/album/3671909/202603300832141881.jpg",
     social: {
        instagram: "",
        whatsapp: "+",
        email: ""
      },
      showSocial: false // Set false untuk menyembunyikan tombol sosial
    },
   {
    id:5,
    userId: "3013349",
    name: "ฬᴹ gendis",
    role: "Technical Host",
    experience: "4+ Years",
    rating: 4.2,
    description: "Together, we can achieve greatness. Let's make it happen!",
    photo: "https://qnoss.momoindo.com/album/3013349/202604192229441080.jpg",
    social: {
        instagram: "",
        whatsapp: "+",
        email: ""
      },
      showSocial: false // Set false untuk menyembunyikan tombol sosial
    },
  ];

  // Fungsi untuk kembali ke halaman utama
  const handleBackToHome = () => {
    navigate('/');
  };

  // Filter hosts berdasarkan role
  const filteredHosts = activeTab === 'all' 
    ? hosts 
    : hosts.filter(host => host.role.toLowerCase().includes(activeTab.toLowerCase()));

  return (
    <div className="profile-page">
      {/* Header */}
      <header className="profile-header">
        <button className="back-button" onClick={handleBackToHome}>
          <i className="fas fa-arrow-left"></i>
          Kembali
        </button>
        <div className="profile-title">
          <h1><i className="fas fa-crown"></i> Profile Host</h1>
          <p>Tim profesional yang siap membantu Anda</p>
        </div>
      </header>

      {/* Tabs Filter */}
      <div className="profile-tabs">
        <button 
          className={`tab-btn ${activeTab === 'all' ? 'active' : ''}`}
          onClick={() => setActiveTab('all')}
        >
          <i className="fas fa-users"></i> Semua Host
        </button>
        <button 
          className={`tab-btn ${activeTab === 'lead' ? 'active' : ''}`}
          onClick={() => setActiveTab('lead')}
        >
          <i className="fas fa-star"></i> Lead Host
        </button>
        <button 
          className={`tab-btn ${activeTab === 'coordinator' ? 'active' : ''}`}
          onClick={() => setActiveTab('coordinator')}
        >
          <i className="fas fa-calendar-alt"></i> Coordinator
        </button>
        <button 
          className={`tab-btn ${activeTab === 'technical' ? 'active' : ''}`}
          onClick={() => setActiveTab('technical')}
        >
          <i className="fas fa-tools"></i> Technical
        </button>
      </div>

      {/* Host Cards Grid */}
      <div className="hosts-grid">
        {filteredHosts.map(host => (
          <div key={host.id} className="host-card">
            <div className="host-card-header">
              <div className="host-photo">
                <img src={host.photo} alt={host.name} />
                <div className="host-badge">
                  <i className="fas fa-crown"></i>
                </div>
              </div>
              <div className="host-info">
                <h3>{host.name}</h3>
                <div className="host-userid">
                  <i className="fas fa-id-card"></i>
                  <span>ID: {host.userId}</span>
                </div>
                <div className="host-role">
                  <i className="fas fa-briefcase"></i>
                  <span>{host.role}</span>
                </div>
              </div>
            </div>
            
            <div className="host-card-body">
              <p className="host-description">{host.description}</p>
              
              <div className="host-stats">
                <div className="stat">
                  <i className="fas fa-clock"></i>
                  <span>Pengalaman: {host.experience}</span>
                </div>
                <div className="stat">
                  <i className="fas fa-star"></i>
                  <span>Rating: {host.rating}/5.0</span>
                </div>
              </div>
            </div>

            {/* Tombol sosial hanya ditampilkan jika showSocial = true */}
            {host.showSocial && (
              <div className="host-card-footer">
                <div className="host-social">
                  <a 
                    href={`https://wa.me/${host.social.whatsapp}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-btn whatsapp"
                  >
                    <i className="fab fa-whatsapp"></i>
                    WhatsApp
                  </a>
                  <a 
                    href={`mailto:${host.social.email}`}
                    className="social-btn email"
                  >
                    <i className="fas fa-envelope"></i>
                    Email
                  </a>
                  <a 
                    href={`https://instagram.com/${host.social.instagram}`}
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-btn instagram"
                  >
                    <i className="fab fa-instagram"></i>
                    Instagram
                  </a>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Team Stats Section */}
      <div className="team-stats">
        <div className="stat-card">
          <i className="fas fa-users"></i>
          <h3>{hosts.length}+</h3>
          <p>Host Professional</p>
        </div>
        <div className="stat-card">
          <i className="fas fa-calendar-check"></i>
          <h3>100+</h3>
          <p>Event Berhasil</p>
        </div>
        <div className="stat-card">
          <i className="fas fa-star"></i>
          <h3>4.8</h3>
          <p>Rating Rata-rata</p>
        </div>
        <div className="stat-card">
          <i className="fas fa-smile"></i>
          <h3>98%</h3>
          <p>Kepuasan Klien</p>
        </div>
      </div>

      {/* CTA Section */}
      <div className="profile-cta">
        <h2>Ingin Bekerja Sama dengan Tim Kami?</h2>
        <p>Hubungi kami untuk konsultasi gratis dan perencanaan event Anda</p>
        <button 
          className="cta-button"
          onClick={() => window.open('https://wa.me/6285930139333?text=Halo,%20saya%20[Nama%20Kamu].%20Saya%20ingin%20bergabung%20dengan%20WM%20MANAGEMENT%20karena%20saya%20tertarik%20dengan%20program%20ini.%20Saya%20siap%20mengikuti%20aturan%20dan%20kontribusi%20positif.%20Mohon%20info%20langkah%20selanjutnya.%20Terima%20kasih%20banyak.', '_blank')}
        >
          <i className="fab fa-whatsapp"></i>
          Hubungi via WhatsApp
        </button>
      </div>

      {/* Footer */}
      <footer className="profile-footer">
        <div className="footer-logo">
          <i className="fas fa-crown"></i>
          <span>WAN MANAGEMENT</span>
        </div>
        <p className="copyright">© 2026 WAN MANAGEMENT - All Rights Reserved</p>
      </footer>
    </div>
  );
};

export default Profile;
